import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import {
  Person as PersonIcon,
  Email as EmailIcon,
  Business as BusinessIcon,
  Store as StoreIcon,
  VpnKey as VpnKeyIcon,
  AccessTime as AccessTimeIcon,
} from "@mui/icons-material";
import { useAuth } from "../../contexts/AuthContext";
import axios from "axios";


const UserProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState({
    loginId: user?.loginId || "",
    username: user?.username || "",
    email: user?.email || "",
    role: user?.role || "",
    company: user?.company?.name || "",
    store: user?.store?.name || "",
    lastLogin: user?.lastLogin || new Date(),
  });

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const response = await axios.get("/api/users/profile");
      setProfile({
        loginId: response.data.loginId || "",
        username: response.data.username || "",
        email: response.data.email || "",
        role: response.data.role || "",
        company: response.data.company?.name || "",
        store: response.data.store?.name || "",
        lastLogin: response.data.lastLogin || new Date(),
      });
    } catch (error) {
      console.error("プロフィールの取得に失敗しました:", error);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          アカウント情報
        </Typography>
        <Divider sx={{ my: 2 }} />
        <List>
          <ListItem>
            <ListItemIcon>
              <VpnKeyIcon />
            </ListItemIcon>
            <ListItemText primary="ログインID" secondary={profile.loginId} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="ユーザー名" secondary={profile.username} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText primary="メールアドレス" secondary={profile.email} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText primary="権限" secondary={profile.role} />
          </ListItem>
          {profile.company && (
            <ListItem>
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText primary="会社" secondary={profile.company} />
            </ListItem>
          )}
          {profile.store && (
            <ListItem>
              <ListItemIcon>
                <StoreIcon />
              </ListItemIcon>
              <ListItemText primary="店舗" secondary={profile.store} />
            </ListItem>
          )}
          <ListItem>
            <ListItemIcon>
              <AccessTimeIcon />
            </ListItemIcon>
            <ListItemText
              primary="最終ログイン"
              secondary={new Date(profile.lastLogin).toLocaleString()}
            />
          </ListItem>
        </List>
        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
          <Button variant="contained" color="primary">
            パスワード変更
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserProfile;
